<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <h5 class="pull-left">
                Advertiser Information
            </h5>

            <button type="button" class="btn btn-black btn-sm pull-right" @click="visible = !visible" style="margin-top: 4px">
                <i class="fa" :class="visible ? 'fa-minus' : 'fa-plus'"></i> {{ visible ? 'Hide' : 'Show' }}
            </button>

            <div class="clearfix"></div>
        </div>

        <div v-if="visible" class="panel-body form-horizontal">
            <text-form-group
                    v-model="orderConfirmation.company_name"
                    name="company_name"
                    label="Name"
                    help-text="The name of the advertiser."
                    :error="getError('company_name')"
            ></text-form-group>

            <text-form-group
                    v-model="orderConfirmation.company_address"
                    name="company_address"
                    label="Address"
                    help-text="The address of the advertiser."
                    :error="getError('company_address')"
            ></text-form-group>

            <text-form-group
                    v-model="orderConfirmation.company_zip_code"
                    name="company_zip_code"
                    label="Zip Code"
                    help-text="The zip code of the advertiser."
                    :error="getError('company_zip_code')"
            ></text-form-group>

            <text-form-group
                    v-model="orderConfirmation.company_city"
                    name="company_city"
                    label="City"
                    help-text="The city of the advertiser."
                    :error="getError('company_city')"
            ></text-form-group>

            <text-form-group
                    v-model="orderConfirmation.company_country"
                    name="company_country"
                    label="Country"
                    help-text="The country of the advertiser."
                    :error="getError('company_country')"
            ></text-form-group>

            <text-form-group
                    v-model="orderConfirmation.company_cvr"
                    name="company_cvr"
                    label="CVR"
                    help-text="The CVR of the advertiser."
                    :error="getError('company_cvr')"
            ></text-form-group>

            <text-form-group
                    v-model="orderConfirmation.company_contact"
                    name="company_contact"
                    label="Contact"
                    help-text="The name of the contact in the advertiser."
                    :error="getError('company_contact')"
            ></text-form-group>
        </div>
    </div>
</template>

<script>
    import Errors from '@/mixins/Errors'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {TextFormGroup},

        model: {
            prop: 'orderConfirmation',
            event: 'order-confirmation-updated'
        },

        mixins: [Errors],

        props: ['orderConfirmation'],
        
        data() {
            return {
                visible: false
            }
        },

        methods: {
            update(key, value) {
                this.$emit('order-confirmation-updated', {...this.orderConfirmation, [key]: value})
            }
        }
    }
</script>
